type TScreenWidth = string;

export const LARGE_DESKTOP_WIDTH = 1650;
export const DESKTOP_WIDTH = 1248;
export const TABLET_WIDTH = 1025;
export const PHONE_WIDTH = 650;

export const LARGE_DESKTOP: TScreenWidth = `${LARGE_DESKTOP_WIDTH}px`;
export const DESKTOP: TScreenWidth = `${DESKTOP_WIDTH}px`;
export const TABLET: TScreenWidth = `${TABLET_WIDTH}px`;
export const PHONE: TScreenWidth = `${PHONE_WIDTH}px`;

export const minWidth = (w: TScreenWidth): string =>
  `@media screen and (min-width: ${w})`;
export const maxWidth = (w: TScreenWidth): string =>
  `@media screen and (max-width: ${w})`;
